import { FormBuilder, FormGroup } from '@angular/forms';
import {
    MyElIrregSanabiliEntity,
    MyElOsservazioniRespPrecRevEntity,
    MyElSanzioniAccessorieRilevazione,
    MyElWarningEntity,
    MyVerbale,
} from '../../../../models/interfaces/revisione.interface';
import { rebuildFormArray } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const buildIrregSanabiliFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elIrregSanabili = myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_IrregSanabili.my_ElIrregSanabili;
    rebuildFormArray(fb, elIrregSanabili, form, `${formPaths.conclusioni}.my_IrregSanabili.my_ElIrregSanabili`, buildIrregSanabiliGroup);
};

export const buildIrregSanabiliGroup = (fb: FormBuilder, item?: MyElIrregSanabiliEntity): FormGroup => {
    return fb.group({
        my_DescIrregSanabili: item?.my_DescIrregSanabili,
    });
};

export const buildSanzioniAccessorieRilevazioneFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elSanzioni = myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_SanzioniAccessorieRilevazione.my_ElSanzioniAccessorieRilevazione;
    rebuildFormArray(fb, elSanzioni, form, `${formPaths.conclusioni}.my_SanzioniAccessorieRilevazione.my_ElSanzioniAccessorieRilevazione`, buildSanzioniAccessorieRilevazioneGroup);
};

export const buildSanzioniAccessorieRilevazioneGroup = (fb: FormBuilder, item?: MyElSanzioniAccessorieRilevazione): FormGroup => {
    return fb.group({
        my_idEsitoRevisioneRilevazione: item?.my_idEsitoRevisioneRilevazione,
        my_DescrizioneRilevazione: item?.my_DescrizioneRilevazione,
        my_CkSanzioniAccessorieRilevazione: item?.my_CkSanzioniAccessorieRilevazione,
        my_HelpSanzioniAccessorieRilevazione: item?.my_HelpSanzioniAccessorieRilevazione,
    });
};

/** Motivi diffida: sottoinsieme calcolato di my_Warning.my_ElWarning, filtrato sui soli warning visibili */
export const buildWarningAuxFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const visibleWarnings = (myVerbale.my_Warning?.my_ElWarning ?? []).filter((w) => w.my_VisibWarning === '1');
    rebuildFormArray(fb, visibleWarnings, form, `${formPaths.conclusioni}.my_WarningAux.my_ElWarningAux`, buildWarningAuxGroup);
};

export const buildWarningAuxGroup = (fb: FormBuilder, item?: MyElWarningEntity): FormGroup => {
    return fb.group({
        my_DescWarning: item?.my_DescWarning,
        my_NoteWarning: item?.my_NoteWarning,
        my_VisibWarning: item?.my_VisibWarning,
    });
};

export const buildOsservazioniRespPrecRevFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elOsservazioni = myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_OsservazioniRespPrecRev.my_elOsservazioniRespPrecRev;
    rebuildFormArray(
        fb,
        elOsservazioni,
        form,
        `${formPaths.conclusioni}.my_OsservazioniRespPrecRev.my_elOsservazioniRespPrecRev`,
        buildOsservazioniRespPrecRevGroup
    );
};

export const buildOsservazioniRespPrecRevGroup = (fb: FormBuilder, item?: MyElOsservazioniRespPrecRevEntity): FormGroup => {
    return fb.group({
        my_id: item?.my_id,
        my_testo: item?.my_testo,
        my_data: item?.my_data,
    });
};
